/* eslint-disable no-undef */
import React from "react";
import { Link } from "react-router-dom";
import DocumentService from '../../../../services/DocumentService';
import moment from "moment";
import ToastService from '../../../../services/ToastService';
import MasterService from '../../../../services/MasterService';
import { showLoading } from 'react-global-loading';
class AllDocuments extends React.Component {
  constructor(props) {
    super(props);

    const url = new URL(window.location);

    this.state = {
      document: '',
      documentModal: '',
      docs: [], filteredList: [],
      showModal: false, docType: 1, approved: [], pending: [], currentPage: url.searchParams.get('page') ? parseInt(url.searchParams.get('page')) : 1,
      statusCount: {}, statusType: 1
    };
  }

  componentDidMount = () => {
    this.getAllDocuments(this.state.currentPage, this.state.statusType);
  };

  getAllDocuments = (page, status) => {
    DocumentService.getAllDocuments({ 'page': page, 'status': status }).then((result) => {
      if (!result) return;
      showLoading(true);
      this.setState((prevState) => ({
        statusCount: result,
        filteredList: [...prevState.filteredList, ...result.data]
      }));
      showLoading(false);

    }).catch((err) => {
      console.error(err);
    });
  };

  onShowModal = (item) => {

    this.setState({ documentModal: item });
  };

  eventType = (page, type) => {
    let filteredList = [];
    this.setState({ statusType: type });
    const url = new URL(window.location);
    url.searchParams.set('page', page);
    window.history.pushState(null, '', url.toString());
    this.getAllDocuments(page, type);
    this.setState({ filteredList });
  }

  onDocApproval = (status) => {
    var data = {
      "ID": this.state.documentModal.ID,
      "post_status": status,
      "blog_id": this.state.documentModal.country?.id
    };

    DocumentService.updateStatus(data).then((result) => {

      result.data === 200 ? (
        ToastService.success(result.data.message),
        window.location.reload(false)) :
        (ToastService.error(result.data.message), window.location.reload(false));

    });
  };

  pdfDownload = () => {

    const { docType, filteredList } = this.state;
    MasterService.getPdf("Documents", filteredList, docType);
  };

  onLoad = () => {
    this.setState({ currentPage: parseInt(this.state.currentPage) + 1 })
    this.getAllDocuments(this.state.currentPage + 1, this.state.statusType)

    const url = new URL(window.location);
    url.searchParams.set('page', this.state.currentPage + 1);
    window.history.pushState(null, '', url.toString());
  }
  render() {
    const { filteredList, documentModal, statusCount, statusType } = this.state;
    let fullyLoaded;
    switch (statusType) {
      case 1://all
        fullyLoaded = filteredList.length === statusCount.total ? true : false;
        break;
      case 2://pending
        fullyLoaded = filteredList.length === statusCount.pending ? true : false;
        break;
      case 3://approved
        fullyLoaded = filteredList.length === statusCount.approved ? true : false;
        break;
    }
    return (
      <>
        <div className="container-fluid productscontainer" id="main">
          <nav aria-label="breadcrumb">
            {/* <ol className="breadcrumb">
              <li className="breadcrumb-item"><a href="#">Home</a></li>
              <li className="breadcrumb-item active" aria-current="page">View Documents</li>
            </ol> */}
          </nav>

          <hr></hr>
          <div className="row mt-3">
            <div className="col-md-6">
              <h3><b>Documents</b></h3>
            </div>
            <div className="col-md-6 btr">
              {/* <button className="btn btndbg" onClick={() => this.pdfDownload()}>
                Export
              </button > */}
              <Link to='/super/add-documents' className="btn theme-btn-fill btndbg"> Add New Document
              </Link >
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-12">
              <ul className="nav nav-tabs admintabs" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button className="nav-link active" id="view-all-documents-tab" onClick={() => this.eventType(1, 1)} data-bs-toggle="tab" type="button" role="tab" aria-selected="true">All <span className="badge text-bg-secondary rounded-circle">{statusCount.total}</span></button>
                </li>
                <li className="nav-item" role="presentation">
                  <button onClick={() => this.eventType(1, 3)} className="nav-link" id="all-pendingapprove-documents-tab" data-bs-toggle="tab" type="button" role="tab" aria-selected="false"> Approved <span className="badge text-bg-secondary rounded-circle">{statusCount.approved}</span></button>
                </li>
                <li className="nav-item" role="presentation">
                  <button onClick={() => this.eventType(1, 2)} className="nav-link" id="all-pendingapprove-documents-tab" data-bs-toggle="tab" type="button" role="tab" aria-selected="false">Pending <span className="badge text-bg-secondary rounded-circle">{statusCount.pending}</span></button>
                </li>
              </ul>
              <div className="tab-content bg-white pt-4 px-4 mt-4" >
                <div className="tab-pane fade show active" role="tabpanel" aria-labelledby="#allcountries">

                  <div className="row" id="#allcountries">
                    <div className=" mt-2">
                      <div className="row view-group">
                        {filteredList.length > 0 ?
                          filteredList.map((item, index) =>

                            <div key={index} className="col-lg-3 col-md-4 col-sm-6 mb-3" data-bs-toggle="modal" data-bs-target="#docModal" >
                              <div className="card p-2 event-card crdev" onClick={() => this.onShowModal(item)} >
                                <div className="imgrel">
                                  <img src={require('../../../../public/pdf_view-all.png')} className=" card-img-top rounded" alt="events" style={{ width: '50px', objectFit: 'cover' }} />
                                </div>
                                <div className="evtxcn px-0 dctx">
                                  <h4 className="evh">
                                    <span className="evhd crop-text" onClick={() => this.onShowModal(item)}>{item.post_title}</span>
                                  </h4>
                                  <p className="evdes_nw">{item.post_content}</p>
                                  <div className="domls">
                                    <div className="domaincell">
                                      {item.category[0]?.name}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="crbotm">
                                <p className="dtpr">Created - <span className="cdte">{moment(item.post_date).format("Do MMM YYYY")}</span></p>
                              </div>
                            </div>
                          ) : <span>No Documents found</span>}
                      </div>
                      {fullyLoaded ? <span> </span> : <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          style={{
                            backgroundColor: "#beeadc",
                            border: "none",
                            borderRadius: "10px",
                            padding: "10px 2rem",
                            fontWeight: "semibold",
                          }}
                          onClick={e => this.onLoad()}
                        >
                          Load More
                        </button>
                      </div>}

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ---------------- Document Approval Popup ---------------- */}
        <div className="modal fade" id="docModal" tabIndex="-1" aria-labelledby="docapprovalLabel" aria-hidden="true">
          <div className="modal-dialog modal-xl">
            <div className="modal-content bg-white p-3">
              <div className="modal-header">
                <h1 className="modal-title fs-5 w-100" id="docapprovalLabel">Document Details</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12 p-3 mb-4 docvwtop">
                    <h5 className="crop-text dctx">{documentModal.post_title}</h5>
                    <p className="crop-text dctx">{documentModal.post_content}</p>
                    <div className="row apdprow">
                      <div className="mb-3 flga">
                        <b className="ml-15">Uploaded on -</b> <span>{moment(documentModal.post_date).format("Do MMM YYYY")}</span>
                      </div>
                      <div className="text-start mob-btn-col docbtn">
                        {documentModal.post_status === 'pending' ? <button type="button" className="btn theme-btn-fill btndbg pd-tb-675em border-2" onClick={() => this.onDocApproval('publish')}>Approve</button> :
                          <button type="button" className="btn theme-btn-outline pd-tb-675em border-2 ms-3" onClick={() => this.onDocApproval('pending')}>Disapprove</button>}
                      </div>
                    </div>
                  </div>
                </div >
                <div className="row mt-2 pdfht" aria-labelledby="#label1">
                  <object
                    id="#label1"
                    width="100%"
                    height="100%"
                    type="application/pdf"
                    data={documentModal.document}
                  />
                </div>
              </div >
            </div >
          </div >
        </div >
        {/* ---------------- Document Approval Popup End ---------------- */}

      </>
    );
  }
}
export default AllDocuments;